const parseDate = (value) => {
    const date = new Date(value)
    return Number.isNaN(date.getTime()) ? null : date
}

const toIsoDate = (date) => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}

export const getEndDate = (startDate, nights) => {
    if (!startDate || !nights) return null

    const start = parseDate(startDate)
    if (!start) return null

    const end = new Date(start)
    end.setDate(end.getDate() + Number(nights))

    return toIsoDate(end)
}

export const buildVerifyAvailabilityPayload = ({ startDate, adults, nights, children, productId }) => {
    return {
        start_date: startDate ?? null,
        adults: Number(adults ?? 0),
        night: Number(nights ?? 0),
        children: Array.isArray(children) ? children : [],
        product_id: productId ?? null
    }
}
